import { get } from "../http/platformServer";

export function canPreShipOrder(shopId: number) {
    return get<{canPreShipOrder:boolean,shopId:number}>(
        shopId,
        "/jinritemai/can_pre_ship_order",
        {
            shopId,
        },
        {
            hideModal: true,
        },
    );
}
